<template>
  <div>
    <div class="dashboard-page">
      <div class="mb-2">
        <h1>
          {{ $t("welcomeBack") }}, {{ user.first_name }}
          {{ user.last_name }}
        </h1>
        <p>{{ $t("enhancePracticeEfficiency") }}.</p>
      </div>
      <div class="card">
        <div class="card-header pb-0">
          <div class="customer-select d-flex align-items-end gap-1 flex-wrap">
            <div class="dashboard-filter-field">
              <MultiSelectInput
                :class="'multiselect-zindex'"
                v-model="companyId"
                :options="customers"
                :query="{ isMultiSelect: true }"
                label="companyName"
                :textLabel="$t('customer')"
                trackBy="id"
                :key="companyId"
                moduleName="customers"
                :multiple="false"
                ><template #option="{ props }">
                  <div>
                    <p>
                      {{ props.option.companyNumber }} -
                      {{ props.option.companyName }}
                    </p>
                  </div>
                </template>
              </MultiSelectInput>
            </div>
            <div class="calender dashboard-filter-field">
              <DateRangePicker class="w-100" v-model="dateRange" />
            </div>
            <button @click="resetStats()" class="btn btn-primary">
              {{ $t("reset") }}
            </button>
          </div>
        </div>
        <div class="card-header">
          <h3>{{ $t("casesStatistics") }}</h3>
        </div>
        <div class="card-body">
          <b-row>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("today") }}</h4>
                <h3>{{ cases.today }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("thisWeek") }}</h4>
                <h3>{{ cases.thisWeek }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("thisMonth") }}</h4>
                <h3>{{ cases.thisMonth }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("total") }}</h4>
                <h3>{{ cases.total }}</h3>
              </div>
            </b-col>
          </b-row>
          <div class="chart-header mt-2 mb-1">
            <div class="chart-header-left">
              <h3>{{ $t("statistics") }}</h3>
            </div>
          </div>
          <div class="spiline-chart">
            <Chart :series="cases.series" :labels="cases.labels" />
          </div>
          <b-row>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("active") }}</h4>
                <h3>{{ cases.activeCases }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("flagged") }}</h4>
                <h3>{{ cases.flaggedCases }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("finished") }}</h4>
                <h3>{{ cases.finishedCases }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("trash") }}</h4>
                <h3>{{ cases.trashCases }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mt-2 mb-lg-0">
                <h4>{{ $t("paid") }}</h4>
                <h3>{{ cases.paidCases }}</h3>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-header">
          <h3>{{ $t("customersStatistics") }}</h3>
        </div>
        <div class="card-body">
          <b-row>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("today") }}</h4>
                <h3>{{ customersData.today }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("thisWeek") }}</h4>
                <h3>{{ customersData.thisWeek }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("thisMonth") }}</h4>
                <h3>{{ customersData.thisMonth }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("total") }}</h4>
                <h3>{{ customersData.total }}</h3>
              </div>
            </b-col>
          </b-row>
          <div class="chart-header mt-2 mb-1">
            <h3>{{ $t("statistics") }}</h3>
          </div>
          <div class="spiline-chart">
            <Chart
              :series="[customersData.series]"
              :labels="customersData.labels"
            />
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-header">
          <h3>{{ $t("invoicesStatistics") }}</h3>
        </div>
        <div class="card-body">
          <b-row>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("today") }}</h4>
                <h3>{{ invoices.today }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("thisWeek") }}</h4>
                <h3>{{ invoices.thisWeek }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("thisMonth") }}</h4>
                <h3>{{ invoices.thisMonth }}</h3>
              </div>
            </b-col>
            <b-col cols="6" lg="3" md="3">
              <div class="status-card mb-2 mb-lg-0">
                <h4>{{ $t("total") }}</h4>
                <h3>{{ invoices.total }}</h3>
              </div>
            </b-col>
          </b-row>
          <div class="chart-header mt-2 mb-1">
            <div class="chart-header-left">
              <h3>{{ $t("statistics") }}</h3>
            </div>
          </div>
          <div class="spiline-chart">
            <Chart :series="[invoices.series]" :labels="invoices.labels" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard, BCardText, BLink } from "bootstrap-vue";
import ElementIcon from "@/components/elements/Icon.vue";
import Chart from "./Chart.vue";
import { debounce } from "@/utils/debounce";
import { mapGetters } from "vuex";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import DatePicker from "@/components/DatePicker.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";
import moment from "moment";
import { formatDate } from "@/utils/helpers";

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    ElementIcon,
    Chart,
    MultiSelectInput,
    DatePicker,
    DateRangePicker,
  },
  data() {
    return {
      getStatisticsDebounced: null,
      dateRange: {
        startDate: moment().subtract(30, "days").toDate(),
        endDate: new Date(),
      },
      cases: {
        series: []
      },
      customersData: {
        series: []
      },
      invoices: {
        series: []
      },
      companyId: "",
    };
  },
  computed: {
    ...mapGetters("customers", ["customers"]),
    ...mapGetters("auth", ["user"]),
  },
  created() {
    this.getStatisticsDebounced = debounce(this.getStatistics, 300);
  },
  watch: {
    dateRange() {
      this.getStatisticsDebounced();
    },
    companyId() {
      this.getStatisticsDebounced();
    },
  },
  async mounted() {
    await this.$store.dispatch("customers/list", { isMultiSelect: true });
    await this.getStatistics();
  },
  methods: {
    resetStats() {
      this.dateRange = {
        startDate: moment().subtract(30, "days").toDate(),
        endDate: new Date(),
      };
      this.companyId = null;
    },
    getFormattedDateRange() {
      return {
        startDate: formatDate(this.dateRange.startDate),
        endDate: formatDate(this.dateRange.endDate),
      };
    },
    async getStatistics() {
      try {
        const { startDate, endDate } = this.getFormattedDateRange();
        this.$store.commit("showLoader", true);
        const response = await this.$store.dispatch("caseLists/dashboard", {
          startDate,
          endDate,
          customerId: this.companyId?.id ?? null,
        });
        this.cases = response?.data?.cases ?? {};
        this.customersData = response?.data?.customers ?? {};
        this.invoices = response?.data?.invoices ?? {};
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
  },
};
</script>

<style lang="scss">
.multiselect-zindex {
  .multiselect {
    z-index: 500 !important;
  }
}
</style>
